import { isVectorSource, type VectorSourceDescriptor } from '../../data/model';
import { effectiveVectorSourceForLayer } from '../../joins/effectiveLayer';
import type { LayerDefinition, LayerId } from '../../project/model';
import { selectedFeatureRef, type SelectedFeatureRef } from '../../selection/model';
import type { AppState } from './appState';

export interface LayerStateContext {
  readonly layer: LayerDefinition;
  readonly canonicalSource: VectorSourceDescriptor;
  readonly source: VectorSourceDescriptor;
}

export function layerStateContext(state: AppState, layerId: LayerId): LayerStateContext | null {
  const layer = state.project.layers.find((candidate) => candidate.id === layerId);
  const canonicalSource = layer
    ? state.project.sources.find((candidate) => candidate.id === layer.sourceId)
    : undefined;
  if (!layer || !canonicalSource || !isVectorSource(canonicalSource)) return null;
  const source = effectiveVectorSourceForLayer(state.project.sources, layer);
  return source ? { layer, canonicalSource, source } : null;
}

export function canonicalSelectionRef(
  state: AppState,
  candidate: SelectedFeatureRef,
): SelectedFeatureRef | null {
  const context = layerStateContext(state, candidate.layerId);
  if (!context || context.source.id !== candidate.sourceId) return null;
  const feature = context.canonicalSource.data.features[candidate.sourceFeatureIndex];
  if (!feature) return null;
  const canonical = selectedFeatureRef(
    context.layer.id,
    context.canonicalSource.id,
    feature,
    candidate.sourceFeatureIndex,
  );
  return canonical.key === candidate.key ? canonical : null;
}
